/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Video_Encoding_ExtendedInputs */



/**
* | output |
* | --- |
* | "Encoding extended AD video with frame holds..." |
*
* @param {Audio_Description_Export_Status_Video_Encoding_ExtendedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_encoding_extended = /** @type {((inputs?: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_Encoding_ExtendedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encodage de la vidéo AD étendue avec images figées...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Codierung von erweitertem AD-Video mit Frame-Holds...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codifica di video AD esteso con frame hold...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кодирование расширенного AD-видео с удержанием кадров...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Codificación de vídeo AD extendido con retención de cuadros...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用帧保持功能对扩展 AD 视频进行编码……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム ホールドを使用して拡張 AD ビデオをエンコードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम होल्ड के साथ विस्तारित AD वीडियो को एनकोड करना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Codificação de vídeo AD estendido com retenção de quadros...")
	return /** @type {LocalizedString} */ ("Encoding extended AD video with frame holds...")
});